const carouselItems = [
  {
    title: '斗破苍穹',
    desc: '天才少年萧炎在创造了家族空前的修炼纪录后，突然成了废人。种种打击接踵而至，就在他即将绝望之时，一缕幽魂从他手上的戒指里浮现……',
    tag: '玄幻修仙',
    img: 'https://readdy.ai/api/search-image?query=A%20young%20warrior%20in%20flowing%20robes%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20fantasy%20landscape%20with%20floating%20islands%2C%20Chinese%20martial%20arts%20fantasy%20style%2C%20warm%20golden%20sunset%20lighting%2C%20epic%20cinematic%20composition%2C%20no%20text&width=700&height=420&seq=carousel-feature-01&orientation=landscape',
  },
  {
    title: '一人之下',
    desc: '普通大学生张楚岚在爷爷坟前遭遇神秘少女冯宝宝，从此被卷入异人世界的纷争之中，揭开了一段不为人知的身世之谜。',
    tag: '奇幻冒险',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20urban%20fantasy%20scene%20with%20a%20young%20man%20and%20girl%20in%20modern%20Chinese%20city%20at%20night%2C%20supernatural%20energy%20effects%2C%20warm%20orange%20street%20lights%2C%20cinematic%20noir%20style%2C%20no%20text&width=700&height=420&seq=carousel-feature-02&orientation=landscape',
  },
  {
    title: '镇魂街',
    desc: '应届大学毕业生夏铃在求职之际，收到了一条奇怪的面试通知，误入罗刹街并遭遇危险，幸而被镇魂将曹焱兵搭救，从此命运改变。',
    tag: '热血战斗',
    img: 'https://readdy.ai/api/search-image?query=An%20epic%20battle%20scene%20with%20spirit%20guardians%20and%20warriors%20in%20a%20mystical%20ancient%20Chinese%20street%20setting%2C%20dramatic%20lighting%20with%20fire%20and%20energy%20effects%2C%20warm%20coral%20and%20amber%20tones%2C%20no%20text&width=700&height=420&seq=carousel-feature-03&orientation=landscape',
  },
  {
    title: '狐妖小红娘',
    desc: '根据古典小说记载，世上有人有妖，妖会与人相恋。妖寿命千万年，人的寿命有限。人死了，妖还活着。人会投胎转世，投胎以后不记得上辈子的爱……',
    tag: '恋爱仙侠',
    img: 'https://readdy.ai/api/search-image?query=A romantic fantasy scene with a fox spirit girl in traditional Chinese dress under ablooming cherry tree, soft pink and warm golden lighting, ethereal atmosphere, no text&width=700&height=420&seq=carousel-feature-04&orientation=landscape',
  },
  {
    title: '完美世界',
    desc: '一粒尘可填海，一根草斩尽日月星辰，弹指间天翻地覆。群雄并起，万族林立，诸圣争霸，乱天动地。一个少年从大荒中走出，一切从这里开始……',
    tag: '玄幻史诗',
    img: 'https://readdy.ai/api/search-image?query=A%20young%20boy%20walking%20through%20a%20vast%20primitive%20wilderness%20with%20ancient%20ruins%20and%20giant%20beasts%20in%20the%20distance%2C%20epic%20fantasy%20landscape%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20scope%2C%20no%20text&width=700&height=420&seq=carousel-feature-05&orientation=landscape',
  },
  {
    title: '大王饶命',
    desc: '灵气复苏时代，吕树依靠毒舌能力和收集负面情绪值来强化自身。一个靠吐槽变强的少年，将在这个灵气复苏的世界掀起怎样的波澜？',
    tag: '搞笑日常',
    img: 'https://readdy.ai/api/search-image?query=A%20humorous%20modern%20school%20scene%20with%20a%20teenage%20boy%20with%20a%20mischievous%20expression%2C%20surrounded%20by%20comic%20speech%20bubbles%20and%20exaggerated%20reaction%20effects%2C%20warm%20and%20bright%20lighting%2C%20no%20text&width=700&height=420&seq=carousel-feature-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          精选推荐
        </h2>
        <p className="text-foreground-600 text-sm text-center mb-10 md:mb-14 max-w-xl mx-auto">
          编辑精选的高分免费漫画，每一部都值得细细品读
        </p>
        <div>
          <div className="flex flex-wrap justify-center gap-5">
            {carouselItems.map((item, idx) => (
              <div
                key={idx}
                className="w-full sm:w-[calc(50%-10px)] lg:w-[calc(33.333%-14px)] xl:w-[calc(16.666%-17px)] min-w-[260px] bg-background-100 rounded-xl overflow-hidden group cursor-pointer hover:bg-background-200/60 transition-colors"
              >
                <div className="overflow-hidden">
                  <img
                    src={item.img}
                    alt={`${item.title} - ${item.tag}`}
                    title={`星球漫画精选推荐：${item.title}`}
                    className="w-full aspect-[5/3] object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <h3 className="font-heading text-base text-foreground-900">
                      {item.title}
                    </h3>
                    <span className="px-2 py-0.5 rounded text-[10px] bg-primary-100 text-primary-700 font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-foreground-500 text-xs leading-relaxed line-clamp-3">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}